export default __webpack_public_path__ + "static/media/Group 3321 mob.ec9fdf38.png";